module.exports = __webpack_public_path__ + "img/ship.61169330.jpg";